import React, { useContext, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';
import { Context } from '../..';
import styles from './AdminApplicationsPage.module.scss';

const AdminApplicationsPage: React.FC = () => {
  const { store } = useContext(Context);
  const [filteredApplications, setFilteredApplications] = useState(store.applications);
  const [filterStatus, setFilterStatus] = useState('all');
  const [sortOrder, setSortOrder] = useState('asc');

  useEffect(() => {
    const fetchApplications = async () => {
      await store.getApplications();
      setFilteredApplications(store.applications);
    };

    fetchApplications();
  }, [store]);

  useEffect(() => {
    let applications = store.applications.slice(); // Create a copy of the array

    if (filterStatus !== 'all') {
      applications = applications.filter(app => app.status === filterStatus);
    }

    applications = applications.sort((a, b) => {
      if (sortOrder === 'asc') {
        return new Date(a.createdAt) > new Date(b.createdAt) ? 1 : -1;
      } else {
        return new Date(a.createdAt) < new Date(b.createdAt) ? 1 : -1;
      }
    });

    setFilteredApplications(applications);
  }, [filterStatus, sortOrder, store.applications]);

  const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFilterStatus(e.target.value);
  };

  const handleSortChange = () => {
    setSortOrder(prevSortOrder => (prevSortOrder === 'asc' ? 'desc' : 'asc'));
  };

  return (
    <div className={styles.applications}>
      <h1 className={styles['applications__header']}>Заявки кандидатів</h1>
      <div className={styles['applications__controls']}>
        <select value={filterStatus} onChange={handleStatusChange}>
          <option value="all">Всі</option>
          <option value="Очікує підтвердження">Очікує підтвердження</option>
          <option value="Відмовлено">Відмовлено</option>
          <option value="Запрошено на екзамен">Запрошено на екзамен</option>
          <option value="Активний">Активний</option>
        </select>
        <button onClick={handleSortChange}>
          Сортувати за датою: {sortOrder === 'asc' ? 'По зростанню' : 'По спаданню'}
        </button>
      </div>
      <div className={styles['applications__list']}>
        {filteredApplications.length > 0 ? (
          filteredApplications.map(application => (
            <Link to={`/admin/applications/${application.id}`} key={application.id} className={styles['applications__item']}>
              <p className={styles['applications__item-title']}>ISO №{application.certification.ISO} - {application.certification.name}</p>
              <p className={styles['applications__item-title']}>ПІБ: {application.full_name}</p>
              {application.certification.photo && (
                <img src={`${process.env.REACT_APP_BASE_URL}/images/${application.certification.photo}`} alt={application.certification.name} className={styles['applications__item-img']} />
              )}
              <p className={styles['applications__item-description']}>{application.status}</p>
              <p className={styles['applications__item-date']}>Дата подачі: {new Date(application.createdAt).toLocaleDateString()}</p>
              <div className={styles['result-block']}>
                {application.status === 'Відмовлено' && (
                  <p>Причина відхилення: {application.refusal_reason}</p>
                )}
                {application.status === 'Запрошено на екзамен' && (
                  <>
                    <p>Дата запрошення: {application.invitation_date}</p>
                    <p>Місце запрошення: {application.invitation_location}</p>
                    <p>Контактні дані: {application.contact_details}</p>
                  </>
                )}
                {application.status === 'Активний' && (
                  <p>Оцінка: {application.approvalScore}</p>
                )}
              </div>
            </Link>
          ))
        ) : (
          <p className={styles['applications__no-items']}>Немає заявок за вибраними критеріями.</p>
        )}
      </div>
    </div>
  );
};

export default observer(AdminApplicationsPage);
